module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Gift.28803277.svg";